import {
  Box,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import { useFilterParams } from '@hooks';

import {
  StyledCollapse,
  StyledTable,
  StyledTableCellCollapse,
  StyledTableHead,
  StyledTableRow,
} from './styles';
import { columnsMainRow, columnsSubRow } from '../../../../constants/columns';
import {
  CoparticipationMainRow,
  CoparticipationPagination,
  CoparticipationSubTable,
} from './components';
import type { CoparticipationPreviewCardProps } from '../../types';

export function CoparticipationPreviewReportTable({
  copartData,
}: CoparticipationPreviewCardProps) {
  const [openRows, setOpenRows] = useState<Record<string, boolean>>({});
  const { handlePageChange, currentPage } = useFilterParams();

  const toggleRow = (id: string) => {
    setOpenRows(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const handleChangePage = (_event: unknown, newPage: number) => {
    handlePageChange(newPage);
  };

  return (
    <>
      <Stack>
        <TableContainer sx={{ maxHeight: 1200, maxWidth: '100%' }}>
          <StyledTable stickyHeader aria-label="sticky table">
            <StyledTableHead>
              <StyledTableRow>
                {columnsMainRow.map(column => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    width={column.width}
                  >
                    <Typography variant="text" fontWeight={400} width="52px">
                      {column.label}
                    </Typography>
                  </TableCell>
                ))}
                <TableCell sx={{ width: '5%' }} />
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              {copartData.coparticipationPreviewReports.map(row => (
                <React.Fragment key={row.id}>
                  <CoparticipationMainRow
                    row={row}
                    columnsMainRow={columnsMainRow}
                    open={Boolean(openRows[row.id])}
                    onToggle={toggleRow}
                  />
                  <TableRow>
                    <StyledTableCellCollapse
                      colSpan={columnsMainRow.length + 1}
                      open={openRows[row.id]}
                    >
                      <StyledCollapse
                        in={openRows[row.id]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box>
                          <CoparticipationSubTable
                            details={row.beneficiaryProcedures}
                            columnsSubRow={columnsSubRow}
                          />
                        </Box>
                      </StyledCollapse>
                    </StyledTableCellCollapse>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>

        <CoparticipationPagination
          coparticipationCount={copartData.coparticipationPreviewReports.length}
          handleChangePage={handleChangePage}
          currentPage={currentPage}
          total={copartData.total}
        />
      </Stack>
    </>
  );
}
